import React, { createContext, useContext, useState, useEffect } from 'react';
import { buildApiUrl } from '../config/api';

const EnumContext = createContext(null);

// Fallback values used while the API is loading or if it fails
const FALLBACK_ENUMS = {
  brands: {},
  categories: {},
  proteinTypes: {},
  textures: {},
  textureGroups: {},
  healthBenefits: [],
  lifestages: {},
  formats: {},
  noveltyProteinList: [],
  booleanOptions: {},
};

export const EnumProvider = ({ children }) => {
  const [enums, setEnums] = useState(FALLBACK_ENUMS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Try localStorage cache first for instant render
    const cached = localStorage.getItem('app_enums');
    if (cached) {
      try {
        setEnums(JSON.parse(cached));
        setLoading(false);
      } catch (e) {
        // ignore bad cache
      }
    }

    // Fetch fresh data
    fetch(buildApiUrl('/api/enums'))
      .then(res => res.json())
      .then(data => {
        setEnums(data);
        setLoading(false);
        localStorage.setItem('app_enums', JSON.stringify(data));
      })
      .catch(err => {
        console.error('Failed to fetch enums:', err);
        setLoading(false);
      });
  }, []);

  return (
    <EnumContext.Provider value={{ ...enums, loading }}>
      {children}
    </EnumContext.Provider>
  );
};

/**
 * Hook to access enum values fetched from the API.
 * Returns: { brands, categories, proteinTypes, textures, healthBenefits,
 *            lifestages, formats, noveltyProteinList, booleanOptions, loading }
 */
export const useEnums = () => {
  const ctx = useContext(EnumContext);
  if (!ctx) {
    throw new Error('useEnums must be used within an EnumProvider');
  }
  return ctx;
};
